import {
  Icon,
  Col,
  Row,
  Button,
  Loading,
  Toast,
  Dialog,
  Picker,
  Popup,
  Field,
  Cascader,
  Empty,
  Sticky,
  Divider,
  Calendar,
  Checkbox,
  CheckboxGroup,
  List,
  ShareSheet,
  Tabs,
  Tab,
  Popover,
  Overlay,
  Grid,
  GridItem,
  Slider,
  Notify,
  DropdownMenu,
  DropdownItem,
  Uploader,
  ImagePreview,
  DatetimePicker,
  RadioGroup,
  Radio,
  Rate,
  Swipe,
  SwipeItem,
  Progress,
  Pagination
} from 'vant'

const vant = {
  install: function(Vue) {
    Vue.use(Icon)
    Vue.use(Col)
    Vue.use(Row)

    Vue.use(Button)
    Vue.use(Loading)
    Vue.use(Toast)
    Vue.use(Dialog)
    Vue.use(Picker)
    Vue.use(Popup)
    Vue.use(Field)
    Vue.use(Cascader)
    Vue.use(Empty)
    Vue.use(Sticky)
    Vue.use(Divider)
    Vue.use(Calendar)
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    Vue.use(List)
    Vue.use(ShareSheet)
    Vue.use(Tabs)
    Vue.use(Tab)
    Vue.use(Popover)
    Vue.use(Grid)
    Vue.use(GridItem)
    Vue.use(Slider)
    Vue.use(Notify)
    Vue.use(Overlay)
    Vue.use(DropdownMenu)
    Vue.use(DropdownItem)
    Vue.use(Uploader)
    Vue.use(ImagePreview)
    Vue.use(DatetimePicker)
    Vue.use(Radio)
    Vue.use(RadioGroup)
    Vue.use(Rate)
    Vue.use(Swipe)
    Vue.use(SwipeItem)
    Vue.use(Progress)
    Vue.use(Pagination)
  }
}

export default vant
